/**
 * Style Adjustments
 * Markt- und seitenspezifische Style-Anpassungen
 *
 * Market Handle ist verfügbar über: document.documentElement.dataset.market
 * Beispiel: if (document.documentElement.dataset.market === 'germany') { ... }
 */

document.addEventListener("DOMContentLoaded", function () {
  const market = document.documentElement.dataset.market || "";
  const path = window.location.pathname;

  // ============================================
  // Cart Page: Hide cart drawer block
  // ============================================
  if (path === "/cart") {
    injectStyle(`
      .bmsm-cart-drawer-block {
        display: none !important;
      }
    `);
  }

  // ============================================
  // Store Locator Pages: Hide sticky announcement bar
  // ============================================
  if (
    path.includes("/pages/store-locator") ||
    path.includes("/pages/stores/")
  ) {
    injectStyle(`
      .bmsm-stickyannouncementbar {
        display: none !important;
      }
    `);
  }
  // ============================================
  // Other pages with announcement bar: Adjust floating filter
  // ============================================
  else if (document.querySelector(".bmsm-stickyannouncementbar")) {
    injectStyle(`
      .facets__floating-filter {
        transform: translateY(-60px) !important;
      }
    `);
  }

  // ============================================
  // Market-specific adjustments
  // ============================================

  // Global Market: Hide product page block and wk-floating on product pages
  if (market === "global") {
    injectStyle(`
      .bmsm-product-page-block,
      .bmsm-stickyannouncementbar,
      .wk-floating,
      [data-test-id="userlike-container"] {
        display: none !important;
      }
      
      /* Hide price filter */
      details[id*="price"] {
        display: none !important;
      }
      
          `);

    // Hide availability filter with JavaScript (more reliable)
    const availabilityInputs = document.querySelectorAll(
      'input[name*="availability"]'
    );
    availabilityInputs.forEach((input) => {
      const accordion = input.closest(".accordion");
      if (accordion) {
        accordion.style.display = "none";
      }
    });

    // Hide price sorting options in shadow DOM
    function hidePriceSortOptions() {
      // Try to find shadow DOM elements
      const allElements = document.querySelectorAll("*");
      allElements.forEach((element) => {
        if (element.shadowRoot) {
          const priceOptions =
            element.shadowRoot.querySelectorAll('[value*="price"]');
          priceOptions.forEach((option) => {
            option.style.display = "none";
          });
        }
      });

      // Also try direct query for popover elements
      const popoverOptions = document.querySelectorAll(
        '.popover-listbox__option[value*="price"]'
      );
      popoverOptions.forEach((option) => {
        option.style.display = "none";
      });
    }

    // Run immediately and on DOM changes
    hidePriceSortOptions();

    // Remove is-disabled class from variant picker options on product pages
    function removeVariantDisabledState() {
      const variantLabels = document.querySelectorAll(
        ".variant-picker__option-values label.is-disabled"
      );
      variantLabels.forEach((label) => {
        label.classList.remove("is-disabled");
      });
    }

    // Run immediately
    removeVariantDisabledState();

    // Watch for DOM changes (for dynamic content)
    const observer = new MutationObserver(() => {
      hidePriceSortOptions();
      removeVariantDisabledState();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});

/**
 * Helper: Inject CSS into head
 * @param {string} css - CSS string to inject
 */
function injectStyle(css) {
  const style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);
}
